var e4 = e4 || {},
    ambu = ambu || {};
( function () {
    'use strict';
    jQuery( function () {
        ambu.init();
    } );
    jQuery( window ).on( 'load', function () {
        ambu.video.load();
        ambu.deferImages.init();
        var urlHash = window.location.hash;
        // if url contains target ID (hash), we trigger reload to scroll down to content after cookie click
        if(urlHash !== "") {
            jQuery( '.coi-banner__accept, .coi-banner__decline' ).on( 'click', function() {
                e4.scrollToAnchor.goToLocationHash();
            });
        }
    } );
    ambu.init = function () {
        ambu.utils.init();
        ambu.svg.init();
        ambu.cta.init();
        ambu.ctaBasic.init();
        ambu.dealersearch.init();
        ambu.countrydetector.init();
        ambu.featuredWithHotspots.init();
        ambu.approveFromCustomerStep();
        ambu.euroland.init();
        ambu.globenewswire.init();
        ambu.disclaimer.init();
        ambu.hotjar.init();
        ambu.removeButton();
        ambu.card.init();
        ambu.custombanner.init();
        ambu.imageMap.init();
        ambu.tooltip.init();
    };
    ambu.utils = {
        init: function () {
            ambu.utils.converToSuperscript();
        },
        converToSuperscript: function () {
            jQuery( '.e-product-name,.e-product-text,.ambu-banner-text,.e-product-section' ).each( function () {
                var html = jQuery( this ).html();
                if ( html.indexOf( '™' ) > -1 || html.indexOf( '©' ) > -1 || html.indexOf( '®' ) > -1 ) {
                    html = html.replace( /[™®©]/g, '<sup>$&</sup>' );
                    jQuery( this ).html( html );
                }
            } );
        }
    };
    ambu.video = {
        load: function () {
            jQuery( 'video:not(.js-e-content-defer)' ).each(function(index, element) {
                ambu.deferImages.setVideoSrc( element );
            });
        }
    };
    ambu.hotjar = {
        init: function () {
            // Trigger name should always be lowercase
            jQuery( '.e-dropdown-mega.products' ).find( '.dropdown-toggle' ).on( 'click', function ( event ) {
                event.preventDefault()
            } );
            jQuery( '#e-nav-global-child-2812' ).closest( '.dropdown' ).on( 'shown.bs.dropdown', function () {
                if ( typeof hj === 'function' ) {
                    hj( 'trigger', 'megamenu_products' );
                }
            } );
            jQuery( '#e-nav-global-child-2810' ).closest( '.dropdown' ).on( 'shown.bs.dropdown', function () {
                if ( typeof hj === 'function' ) {
                    hj( 'trigger', 'megamenu_about' );
                }
            } );
            jQuery( '#e-nav-global-child-4336' ).closest( '.dropdown' ).on( 'shown.bs.dropdown', function () {
                if ( typeof hj === 'function' ) {
                    hj( 'trigger', 'megamenu_products_ambuusa' ); 
                }
            } );
            jQuery( '#ambu-getquote' ).closest( '.modal' ).on( 'shown.bs.modal', function () {
                if ( typeof hj === 'function' ) {
                    hj( 'trigger', 'modal_getquote' );
                }
            } );
            jQuery( '#ambu-cart-variants-quote' ).on( 'shown.bs.modal', function () {
                if ( typeof hj === 'function' ) {
                    hj( 'trigger', 'modal_getquote' );
                }
            } );
            jQuery( '#ambu-cart-formular' ).on( 'shown.bs.modal', function () {
                if ( typeof hj === 'function' ) {
                    hj( 'trigger', 'modal_tryit' );
                }
            } );
        }
    };
    ambu.euroland = {
        script: {
            test: 'window.jQuery.fn.EurolandIFrameAutoHeight',
            url: '//tools.euroland.com/tools/common/eurolandiframeautoheight/eurolandtoolsintegrationobject.js',
            //url: '/files/templates/designs/ambu/assets/js/vendor/eurolandtoolsintegrationobject.js',
            fallback: '/files/templates/designs/ambu/assets/js/vendor/eurolandtoolsintegrationobject.js',
            callback: null
        },
        init: function () {
            var jEurolandIframes = jQuery( '.js-ambu-euroland-iframe' );
            if ( jEurolandIframes.length > 0 ) {
                e4.util.require.js( ambu.euroland.script, function () {
                    jEurolandIframes.EurolandIFrameAutoHeight();
                } );
            }
        }
    };
    ambu.globenewswire = {
        unsubscribe: function () {
            jQuery( '.js-ambu-globenewswire-form-unsubscribe' ).submit( function ( e ) {
                var valid = true;

                if ( jQuery( 'input[type="email"]' ).val() === '' ) {
                    valid = false;
                }

                if ( !valid ) {
                    jQuery( 'input[type="email"]' ).addClass( 'form-control-danger' );

                    jQuery( 'label.has-error' ).show();
                    e.preventDefault( e );
                }
            } );
        },
        init: function () {
            if ( jQuery( '#form_subcap' ).length === 1 && jQuery.isFunction( ambu.globenewswire_vendor ) === true ) {
                ambu.globenewswire_vendor();
            }
            ambu.globenewswire.unsubscribe();
        }
    };

    ambu.disclaimer = {
        settings: {
            disallowedCountries: [ 'US', 'CA', 'AU', 'JP' ],
            disallowedUrl: '/disallowed',
            triggers: {
                reports: [ 'Q4_Annual_Report_201617_pdf', 'Q4_Aarsrapport_201617_pdf' ], //'Q3_Company_announcement_no__15_2016_17_pdf',
                news: [ 528, 529, 530, 531, 532, 533, 534, 535, 536, 537 ] //Add 526 or 331 for test
            },
            action: {}
        },
        init: function () {
            ambu.disclaimer.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.ambu-reports' ).on( 'click', '.js-ambu-disclaimer-item', function ( event ) {
                // console.log( jQuery( this ).data( 'id' ) );
                if ( jQuery.inArray( jQuery( this ).data( 'id' ), ambu.disclaimer.settings.triggers.reports ) !== -1 && event.isTrigger !== 3 ) {
                    event.preventDefault();
                    event.stopPropagation();
                    ambu.disclaimer.settings.action = {
                        label: 'download',
                        item: jQuery( this ).data( 'id' )
                    };
                    jQuery( '.ambu-disclaimer-modal' ).modal();
                }
            } );
            jQuery( '.ambu-vertical-events' ).on( 'click', '.js-ambu-disclaimer-item', function ( event ) {
                if ( jQuery( this ).is( '.collapsed' ) === true ) {
                    if ( jQuery.inArray( parseInt( jQuery( this ).data( 'id' ) ), ambu.disclaimer.settings.triggers.news ) !== -1 && event.isTrigger !== 3 ) {
                        event.preventDefault();
                        event.stopPropagation();
                        ambu.disclaimer.settings.action = {
                            label: 'collapse',
                            item: jQuery( this ).data( 'id' )
                        };
                        jQuery( '.ambu-disclaimer-modal' ).modal();
                    }
                }

            } );
            jQuery( '.js-disclaimer-modal-confirm-btn' ).on( 'click', function ( event ) {
                event.preventDefault();
                var country = jQuery( '.js-disclaimer-modal-confirm-value' ).val();
                if ( country ) {
                    if ( jQuery.inArray( country, ambu.disclaimer.settings.disallowedCountries ) !== -1 ) {
                        ambu.disclaimer.actions.disallowed();
                    }
                    else {
                        ambu.disclaimer.actions.allowed();
                    }
                }

            } );
            jQuery( '.js-disclaimer-modal-confirm-again-btn' ).on( 'click', function ( event ) {
                event.preventDefault();
                ambu.disclaimer.actions.confirmed();

            } );
            jQuery( '.ambu-disclaimer-modal' ).on( 'hidden.bs.modal', function ( e ) {
                jQuery( '.ambu-disclaimer-modal' ).find( '.js-disclaimer-select-country-container' ).show();
                jQuery( '.ambu-disclaimer-modal' ).find( '.js-disclaimer-text-container' ).hide();
            } );
            if ( location.pathname === ambu.disclaimer.settings.disallowedUrl ) {
                history.pushState( null, null, document.URL );
                window.addEventListener( 'popstate', function () {
                    history.pushState( null, null, document.URL );
                } );
            }
        },
        actions: {
            allowed: function () {
                jQuery( '.ambu-disclaimer-modal' ).find( '.js-disclaimer-select-country-container' ).hide();
                jQuery( '.ambu-disclaimer-modal' ).find( '.js-disclaimer-text-container' ).removeAttr( 'hidden' ).show();
            },
            confirmed: function () {
                jQuery( '.ambu-disclaimer-modal' ).modal( 'hide' );

                if ( ambu.disclaimer.settings.action.label === 'collapse' ) {
                    jQuery( '[data-id="' + ambu.disclaimer.settings.action.item + '"]' ).trigger( 'click' );
                }
                else if ( ambu.disclaimer.settings.action.label === 'download' ) {
                    location.href = jQuery( '[data-id="' + ambu.disclaimer.settings.action.item + '"]' ).attr( 'href' );
                }
            },
            disallowed: function () {
                location.href = ambu.disclaimer.settings.disallowedUrl;
            }
        }
    };

    ambu.countrydetector = {};
    ambu.countrydetector.init = function () {
        if ( jQuery( '#ambu-country-detector' ).length === 1 ) {
            jQuery( '#ambu-country-detector' ).modal();
        }
    };

    ambu.dealersearch = {
        options: {
            url: '/system/data/dealersearch',
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch' );
                    ambu.dealersearch.bindEvents();
                    ambu.dealersearch.get();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-dealersearch-container' ).on( 'change', '.js-ambu-country-selector', function () {
                jQuery( '.js-ambu-country' ).hide();
                if ( jQuery( this ).val() === '' ) {
                    jQuery( '.js-ambu-country' ).fadeIn( 'slow' );
                }
                else {
                    jQuery( '.js-ambu-country[data-contry-code="' + jQuery( this ).val() + '"]' ).fadeIn( 'slow' );
                }
            } );
        },
        get: function () {
            jQuery.ajax( {
                url: ambu.dealersearch.options.url,
                type: 'GET',
                dataType: 'json'
            } )
                .done( function ( data ) {
                    ambu.dealersearch.build( data );
                } )
                .fail( function ( error ) {
                    console.error( error );
                } );

        },
        build: function ( data ) {
            var jContainer = jQuery( '#js-e-dealersearch-container' );
            jQuery.each( data.selectList, function ( index, country ) {
                if ( country.countryCode === jContainer.data( 'default-country' ) ) {
                    country.isSelected = true;
                }
            } );
            jContainer.html( e4.handlebars.tmpl.handlebarsTmplDealersearch( data ) );
            if ( jQuery( '.js-ambu-frontpage' ).length && ambu.dealersearch.options.lang === 'da' ) {
                jContainer.find( '.js-ambu-country-selector' ).val( 'int' ).trigger( 'change' );
            }
            else {
                jContainer.find( '.js-ambu-country-selector' ).val( jContainer.data( 'default-country' ) ).trigger( 'change' );
            }

        }
    };
    ambu.cta = {
        init: function () {
            var jAmbuCTA = jQuery( '.js-ambu-cta.is-sticky' );
            if ( jAmbuCTA.length === 1 ) {
                ambu.cta.requestingAnimation = false;
                jAmbuCTA.removeClass( 'is-sticky' );
                ambu.cta.intialOffsetTop = jAmbuCTA.offset().top;
                jAmbuCTA.addClass( 'is-sticky' );
                ambu.cta.bindEvents();
                ambu.cta.toggleSticky();
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'scroll', function () {
                if ( ambu.cta.requestingAnimation === false ) {
                    window.requestAnimationFrame( function () {
                        ambu.cta.toggleSticky();
                        ambu.cta.requestingAnimation = false;
                    } );
                }
                ambu.cta.requestingAnimation = true;
            } );
        },
        toggleSticky: function () {
            if ( jQuery( window ).scrollTop() > ambu.cta.intialOffsetTop ) {
                jQuery( '.js-ambu-cta' ).addClass( 'is-stuck' );
            }
            else {
                jQuery( '.js-ambu-cta' ).removeClass( 'is-stuck' );
            }
        }
    };
    ambu.ctaBasic = {
        init: function () {
            var jAmbuCTA = jQuery( '#ambu-primary-cta' );
            if ( jAmbuCTA.length === 1 ) {
                ambu.ctaBasic.requestingAnimation = false;
                jAmbuCTA.removeClass( 'is-fixed' );
                ambu.ctaBasic.intialOffsetTop = jAmbuCTA.offset().top;
                jAmbuCTA.addClass( 'is-fixed' );
                ambu.ctaBasic.bindEvents();
                ambu.ctaBasic.toggleSticky();
                ambu.ctaBasic.modalNoAdjustment();
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'scroll', function () {
                if ( ambu.ctaBasic.requestingAnimation === false ) {
                    window.requestAnimationFrame( function () {
                        ambu.ctaBasic.toggleSticky();
                        ambu.ctaBasic.requestingAnimation = false;
                    } );
                }
                ambu.ctaBasic.requestingAnimation = true;
            } );
        },
        toggleSticky: function () {
            if ( jQuery( window ).scrollTop() > ambu.ctaBasic.intialOffsetTop ) {
                jQuery( '.js-ambu-cta' ).addClass( 'is-fixed' );
            }
            else {
                jQuery( '.js-ambu-cta' ).removeClass( 'is-fixed' );
            }
        },
        modalNoAdjustment: function () {
            var jBody = jQuery( 'body' );
            jQuery( '#ambu-cart-variants-quote' ).on( 'show.bs.modal', function () {
                jBody.addClass( 'modal-open-no-adjustment' );
            } ).on( 'hidden.bs.modal', function () {
                jBody.removeClass( 'modal-open-no-adjustment' );
            } )
        }
    };
    ambu.svg = {};
    ambu.svg.init = function () {
        jQuery( 'img.svg' ).each( function () {
            var $img = jQuery( this );
            var imgID = $img.attr( 'id' );
            var imgClass = $img.attr( 'class' );
            var imgURL = $img.attr( 'src' );

            jQuery.get( imgURL, function ( data ) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery( data ).find( 'svg' );

                // Add replaced image's ID to the new SVG
                if ( typeof imgID !== 'undefined' ) {
                    $svg = $svg.attr( 'id', imgID );
                }
                // Add replaced image's classes to the new SVG
                if ( typeof imgClass !== 'undefined' ) {
                    $svg = $svg.attr( 'class', imgClass + ' replaced-svg' );
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr( 'xmlns:a' );

                // Replace image with new SVG
                $img.replaceWith( $svg );

            }, 'xml' );
        } );
    };
    ambu.featuredWithHotspots = {
        init: function () {
            ambu.featuredWithHotspots.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-feature-hotspots-container' ).on( 'click', '.js-feature-hotspots-hotspot', function ( event ) {
                if ( Math.max( jQuery( window ).width(), window.innerWidth ) > e4.settings.breakpoint.sm ) {
                    event.preventDefault();
                    if ( jQuery( this ).is( '.show' ) ) {
                        jQuery( '.js-feature-hotspots-hotspot' ).removeClass( 'show' );
                    }
                    else {
                        jQuery( '.js-feature-hotspots-hotspot' ).removeClass( 'show' );
                        jQuery( this ).addClass( 'show' );
                    }
                }
                else {
                    var intScrollTarget = jQuery( '#' + jQuery( this ).attr( 'id' ).replace( 'hotspot_', 'feature-card-' ) ).offset().top - 100;
                    e4.scrollToAnchor.animate( intScrollTarget );
                }
            } ).on( 'click', '.feature-hotspots-image', function () {
                jQuery( '.js-feature-hotspots-hotspot' ).removeClass( 'show' );
            } );
        }
    };

    ambu.approveFromCustomerStep = function () {
        // NB. Hvis der skal laves mere logik i denne funktion, skal require funktionerne omskrives til at bruge promises. Spørg Mr. Damngood
        e4.util.require.js( e4.settings.require.jQueryValidate, function () {
            e4.forms.validate.setDefaults();
            jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-approve-order', function ( event ) {
                if ( jQuery( this ).closest( 'form' ).valid() !== true ) {
                    event.preventDefault();
                }
            } );
        } );
    };

    ambu.removeButton = function () {
        jQuery(".btn.btn-quaternary.free-quote").eq(0).addClass("show-button");
    };

    ambu.hcp = {
        init: function () {
            window.addEventListener('CookieInformationConsentGiven', function (event) {
                ambu.hcp.triggerModal();
            });
            if (jQuery.cookie('CookieInformationConsent') !== undefined ) {
                ambu.hcp.triggerModal();
            }
        },
        triggerModal: function () {
            var jModal = jQuery('.js-ambu-hcp-modal');
            if (jQuery.cookie('hcpModalYes') !== 'true' && jQuery('.js-ambu-hcp-disable-alert').length === 0) {
                jModal.modal();
            }
            jModal.on('hide.bs.modal', function () {
                jQuery.cookie('hcpModalYes', 'true', {
                    expires: 365,
                    path: '/'
                });
            });
        }
    };
    ambu.sidebarPopup = {
        init: function () {
            var jSidebarPopup = jQuery('.js-ambu-sidebar-popup'),
                intIconWidth = jSidebarPopup.find('.js-ambu-sidebar-popup-button-btn').find('img').outerWidth() + 15,
                intWindowInnerWidth = window.innerWidth,
                intMobileBreakpoint = 480;

            if ( intWindowInnerWidth >= intMobileBreakpoint ) {
                jSidebarPopup.find('.js-ambu-sidebar-popup-button').css({
                    left: -20
                });

                jSidebarPopup.find('.js-ambu-sidebar-popup-button').on('mouseenter', function () {
                    jSidebarPopup.find('.js-ambu-sidebar-popup-button').animate({
                        left: 0
                    }, 300);
                });
                jSidebarPopup.find('.js-ambu-sidebar-popup-button').on('mouseleave', function () {
                    jSidebarPopup.find('.js-ambu-sidebar-popup-button').animate({
                        left: -20
                    }, 300);
                });
            } else {
                jSidebarPopup.find('.js-ambu-sidebar-popup-button').css({
                    right: -20
                });

                jSidebarPopup.find('.js-ambu-sidebar-popup-button').on('mouseenter', function () {
                    jSidebarPopup.find('.js-ambu-sidebar-popup-button').animate({
                        right: 0
                    }, 300);
                });
                jSidebarPopup.find('.js-ambu-sidebar-popup-button').on('mouseleave', function () {
                    jSidebarPopup.find('.js-ambu-sidebar-popup-button').animate({
                        right: -20
                    }, 300);
                });
            }

            jSidebarPopup.find('.js-ambu-sidebar-popup-button-btn').on('click', function (e) {
                jQuery(this).closest('.js-ambu-sidebar-popup').find('.ambu-sidebar-popup-content').show();
                jQuery(this).closest('.js-ambu-sidebar-popup').find('.js-ambu-sidebar-animation').removeClass('js-ambu-sidebar-animation');
                e.preventDefault();
            });

            jSidebarPopup.find('.js-ambu-sidebar-popup-close').on('click', function (e) {
                jQuery(this).closest('.js-ambu-sidebar-popup').find('.ambu-sidebar-popup-content').hide();
                e.preventDefault();
            }); 
            
        }
    };
    ambu.card = {
        init: function () {
            ambu.card.removeEmptySpacing();
        },
        removeEmptySpacing: function () {
            jQuery('.p-card .card-block p').each(function() {
                var cards = jQuery(this);
                var cardsWithButton = cards.find('a.btn').closest('p');
                var cardsEmptySpacing = cards.find('br');
                
            
                if(cardsWithButton){
                    cardsWithButton.addClass('card-button');
                } else {
                    cardsWithButton.removeClass('card-button');
                }
            
                if(cards.html().replace(/\s|&nbsp;/g, '').length == 0){
                    cards.remove();
                    cardsEmptySpacing.remove(); 
                }
            });
        }
    };
    ambu.custombanner = {
        init: function () {
            ambu.custombanner.makeEqualHeight();
        },
        makeEqualHeight: function () {
            var txtContainer = jQuery('.js-ambu-custom-banner-txt-container').height(),
                imgContainer = jQuery('.js-ambu-custom-banner-img-container');

            if (jQuery(window).width() <= 991)
            {
                ambu.custombanner.setEqualHeight(txtContainer, imgContainer);
            } else
            {
                imgContainer.css('height','');
            }
        },
        setEqualHeight: function (txtContainer, imgContainer) {
            imgContainer.height(txtContainer);
            ambu.custombanner.listenForResize();
        },
        listenForResize: function () {
            var resizeTimer;
            jQuery( window ).on( 'resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(ambu.custombanner.makeEqualHeight, 100);
            }) 
        },
    };
    ambu.imageMap = {
        init: function () {
            if ( jQuery( 'img[usemap]' ).length > 0 ) {
                ambu.imageMap.scale( jQuery( 'img[usemap]' ) );
                ambu.imageMap.generateMobileMenuFromCoords( jQuery( 'img[usemap]' ) );
            }
        },
        scale: function ( image ) {
            var img = image;
            var imageMap = function () {
                img.each( function () {
                    var jThat = jQuery( this );
                    jQuery( '<img />' ).on( 'load', function () {
                        var attrW = 'width',
                            attrH = 'height',
                            w = jThat.attr( attrW ),
                            h = jThat.attr( attrH );
                        if ( !w || !h ) {
                            var temp = new Image();
                            temp.src = jThat.attr( 'src' );
                            if ( !w ) {
                                w = temp.width;
                            }
                            if ( !h ) {
                                h = temp.height;
                            }
                        }
                        var wPercent = jThat.width() / 100,
                            hPercent = jThat.height() / 100,
                            map = jThat.attr( 'usemap' ).replace( '#', '' ),
                            c = 'coords';
                        jQuery( 'map[name="' + map + '"]' ).find( 'area' ).each( function () {
                            var jThis = jQuery( this );
                            if ( !jThis.data( c ) ) {
                                jThis.data( c, jThis.attr( c ) );
                            }
                            var coords = jThis.data( c ).split( ',' ),
                                coordsPercent = new Array( coords.length );
                            for ( var i = 0; i < coordsPercent.length; ++i ) {
                                if ( i % 2 === 0 ) {
                                    coordsPercent[ i ] = parseInt( ( ( coords[ i ] / w ) * 100 ) * wPercent );
                                }
                                else {
                                    coordsPercent[ i ] = parseInt( ( ( coords[ i ] / h ) * 100 ) * hPercent );
                                }
                            }
                            jThis.attr( c, coordsPercent.toString() );
                        } );
                    } ).attr( 'src', jThat.attr( 'src' ) );
                } );
            };
            jQuery( window ).resize( imageMap ).trigger( 'resize' );
            return this;
        },
        generateMobileMenuFromCoords: function ( image ) {
            var img = image;
            img.each( function () {
                var jThat = jQuery( this ),
                    map = jThat.attr( 'usemap' ).replace( '#', '' ),
                    jContainer = jThat.closest('div'),
                    ul = jQuery( '<ul/>' )
                        .addClass( 'nav hidden-lg-up ambu-image-map-container-' + map )
                        .appendTo(jContainer);

                jQuery( 'map[name="' + map + '"]' ).find( 'area' ).each( function () {
                    //console.log("title: " + title);
                    //console.log("href: " + href);
                    var jThis = jQuery( this ),
                        title = jThis.attr( 'title' ),
                        href = jThis.attr( 'href' ),
                        li = jQuery( '<li/>' )
                            .addClass( 'ambu-image-map-item' )
                            .appendTo(ul),
                        a = jQuery( '<a/>' )
                            .addClass( 'ambu-image-map-link btn-link arrow-right' )
                            .attr( 'href', href )
                            .attr( 'target', '_blank' )
                            .html( title )
                            .appendTo(li);
                } );
            } );
        },
    };
    ambu.tooltip = {
        init: function () {
            ambu.tooltip.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-ambu-tooltip-container' ).on( 'click', '.js-ambu-tooltip-link', function ( event ) {
                event.preventDefault();
                if ( jQuery( this ).parent().find('.js-ambu-tooltip-text').hasClass( 'show' ) ) {
                    jQuery( this ).removeClass( 'show' );
                    jQuery( this ).parent().find('.js-ambu-tooltip-text').removeClass( 'show' );
                }
                else {
                    jQuery( this ).addClass( 'show' );
                    jQuery( this ).parent().find('.js-ambu-tooltip-text').addClass( 'show' );
                }
            } );
        }
    };
    ambu.checkoutMarketoForm = {
        getCookieValue: function (name){
            var dc = document.cookie;
            var prefix = name + '=';
            var begin = dc.indexOf('; ' + prefix),
                end;
            
            if (begin === -1) {
                begin = dc.indexOf(prefix);
                if (begin !== 0) {
                    return null;
                }
            }
            else
            {
                begin += 2;
                end = document.cookie.indexOf(';', begin);
                if (end === -1) {
                    end = dc.length;
                }
            }
            return decodeURI(dc.substring(begin + prefix.length, end));
        }
    };
}() );
